import Select, { ListOption } from "@/Atoms/Select/Select";
import React, { forwardRef, useState } from "react";
import debounce from "@/helpers/debounce";
import axios from "axios";
import { relativeRoute } from "@/helpers/relativeRoute";
import { Props as SelectProps } from "react-select";
import CreatePlaceModal from "@/Organisms/Modals/CreatePlaceModal";
import PlaceOption from "@/Atoms/Select/PlaceOption";

export type PlaceSelectProp = {
  description: string
  label: string
  type: string
  value: string
  __isNew__?: boolean
}

type Props = Omit<SelectProps<PlaceSelectProp>, "options" | "loadOptions"> & {
  onChange: (value: PlaceSelectProp | null) => void
  canCreate?: boolean
}

export default forwardRef((props: Props, ref) => {

  const {onChange, canCreate} = props;
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false)
  const [pendingOption, setPendingOption] = useState<string>('');

  const handleCreate = (inputValue: string) => {
    setPendingOption(inputValue);
    setShowCreateModal(true);
  }

  const handleSubmitCreate = ({place}: { place: PlaceSelectProp }) => {
    onChange(place)
    setShowCreateModal(false);
    setPendingOption('');
  }

  const handleCancelCreate = () => {
    setShowCreateModal(false);
    setPendingOption('');
  };

  const debouncedPlaces = debounce((inputValue: string) => {
    return new Promise<ListOption[]>(async (resolve) => {
      const response = await axios.get(relativeRoute('place-search') + '?search=' + inputValue)
      resolve(Array.isArray(response.data) ? response.data : [])
    });
  }, 500, {leading: true})
  const loadOptions = (inputValue: string) => {
    return debouncedPlaces(inputValue);
  }

  const SelectComponent: any = Select;

  return <>
    <SelectComponent
      {...props}
      ref={ref}
      name={'place'}
      isAsync
      isClearable
      isCreatable={canCreate ?? true}
      placeholder={'Zoek naar de plaats of voeg toe'}
      noOptionsMessage={() => 'Geen zoekresultaten'}
      loadingMessage={() => 'Bezig met zoeken...'}
      formatCreateLabel={(input: any) => input}
      onCreateOption={handleCreate}
      loadOptions={loadOptions}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Option: PlaceOption,
      }}
    />
    <CreatePlaceModal
      pendingOption={pendingOption}
      isVisible={showCreateModal}
      onClose={() => handleCancelCreate()}
      onSubmit={(props) => handleSubmitCreate(props)}
    />
  </>
})


